export default class CreateConversationRequest {
    body = '';
    subject = '';
    conversationTopicId = '';
    workerId = '';
}